import { Button, Space, Typography } from 'antd';
import React from 'react';
import { filterConfig } from '../config/filterConfig';
import { useSettingsStore } from '../hooks/useSettingsStore';
import FilterRow from './FilterRow';

const { Title } = Typography;

const FilterList: React.FC = () => {
  const { filters, setFilter, resetFilters } = useSettingsStore();

  return (
    <div>
      {filterConfig.map((cfg, index) => {
        if (cfg.type === 'title') {
          return (
            <Title key={`title-${index}`} level={5} style={{ marginTop: index === 0 ? 0 : 24, marginBottom: 16 }}>
              {cfg.label}
            </Title>
          );
        }

        if (!cfg.key) return null;

        const filterValue = filters[cfg.key as keyof typeof filters];
        if (!filterValue) return null;

        return (
          <FilterRow
            key={cfg.key}
            label={cfg.label}
            from={filterValue.from}
            to={filterValue.to}
            enabled={filterValue.enabled}
            type={cfg.type}
            placeholders={cfg.placeholders}
            tooltip={cfg.tooltip}
            options={cfg.options}
            onFromChange={(v) => setFilter(cfg.key!, "from", v)}
            onToChange={(v) => setFilter(cfg.key!, "to", v)}
            onToggle={cfg.type === "switch" ? ((v) => setFilter(cfg.key!, "enabled", v)) : undefined}
          />
        );
      })}
      <Space style={{ marginTop: 16, justifyContent: 'flex-end', width: '100%', display: 'flex' }}>
        <Button onClick={resetFilters}>Reset Filters</Button>
      </Space>
    </div>
  );
};

export default FilterList;
